import { Component, h, useEffect, useRef } from "@lukekaalim/act";
import { html, PropsFromClass } from "@lukekaalim/act-web";

import classes from './index.module.css';

export type LabeledInputProps = {
  label: string,
} & PropsFromClass<HTMLInputElement>

export const LabeledInput: Component<LabeledInputProps> = ({ label, autofocus, children, ...props }) => {
  const ref = useRef<HTMLInputElement | null>(null);

  useEffect(() => {
    if (autofocus) {
      ref.get()!.focus();
    }
  }, [autofocus])

  return h(html.label, { className: classes.labeledInput }, [
    h(html.div, {}, label),
    h(html.input, { ref, type: 'text', ...props })
  ])
};